<template lang="pug">
  a.button.is-rounded.is-medium.is-absolute(@click="irBottom")
    span.icon
      i.fas.fa-chevron-down
</template>

<script>
  export default {
    name: 'ButtonRoundedTop',
    methods: {
      irBottom() {
        this.$emit('irBottom', true)
      }
    },
  }
</script>

<style scoped>
  .is-absolute {
    position: absolute !important;
    top: 100px;
    right: 15px;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/landing_Componentes/ButtonRoundedTop.vue